import { render, staticRenderFns } from "./UnArchiveButton.vue?vue&type=template&id=7a7cecf8"
import script from "./UnArchiveButton.vue?vue&type=script&lang=js"
export * from "./UnArchiveButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports